exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-enter[data-v-785104ca],.v-leave-to[data-v-785104ca]{opacity:0}.v-enter-to[data-v-785104ca],.v-leave[data-v-785104ca]{opacity:1}.v-enter-active[data-v-785104ca],.v-leave-active[data-v-785104ca]{-webkit-transition:opacity .5s;transition:opacity .5s}", ""]);

// exports
